import g3 from "../../assets/images/gallery/f10.jpg";
import ext from "../../assets/images/gallery/ext.jpg";
import commercial from "../../assets/images/gallery/commercial.jpg";

const ServicesBody = () => {
  return (
    <section className=" section-spacing-50 no-padding-top">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="services-container width-600 margin-auto">
              <div className="services-item">
                <h2>1. Interior Painting</h2>
                <img src={g3} alt="Flexi Painter" />
                <p>
                  Create spaces that feel brighter, cleaner and more inviting
                  with our professional interior painting services. We combine
                  expert prepartion, quality materials and precise application
                  techniques to achieve smooth and long-lasting finishes
                </p>
                <h3>What We Offer</h3>
                <ul className="service-offers">
                  <li>
                    <span className="flexi-magenta">✔︎ </span> Wall Painting
                  </li>
                  <li>
                    <span className="flexi-magenta">✔︎ </span> Ceiling Painting
                  </li>
                  <li>
                    <span className="flexi-magenta">✔︎ </span> Decorative
                    Finishes
                  </li>
                  <li>
                    <span className="flexi-magenta">✔︎ </span> Feature Walls
                  </li>
                  <li>
                    <span className="flexi-magenta">✔︎ </span> Surface
                    Preparation
                  </li>
                  <li>
                    <span className="flexi-magenta">✔︎ </span> Repainting &
                    Renovation Painting
                  </li>
                </ul>
                <h3>Ideal For</h3>
                <ul className="services-ideal">
                  <li>Homes</li>
                  <li>Apartments</li>
                  <li>Offices</li>
                  <li>Hotels</li>
                  <li>Schools</li>
                </ul>
              </div>
              <div className="services-item">
                <h2>2. Exterior Painting</h2>
                <img src={ext} alt="Flexi Painter" />
                <p>
                  Exterior surfaces face constant exposure to weather, moisture
                  and sunlight. Our exterior painting solutions provide both
                  protection and visual appeal, ensuring your property maintains
                  its appearance for years to come
                </p>
                <h3>What We Offer</h3>
                <ul className="service-offers">
                  <li>
                    <span className="flexi-gold">✔︎ </span> House Exterior
                    Painting
                  </li>
                  <li>
                    <span className="flexi-gold">✔︎ </span> Apartment Block
                    Painting
                  </li>
                  <li>
                    <span className="flexi-gold">✔︎ </span> Roof Painting
                  </li>
                  <li>
                    <span className="flexi-gold">✔︎ </span> Waterproof Solutions
                  </li>
                  <li>
                    <span className="flexi-gold">✔︎ </span> Wall Restoration
                  </li>
                  <li>
                    <span className="flexi-gold">✔︎ </span> Surface Preparation
                  </li>
                </ul>
                <h3>Ideal For</h3>
                <ul className="services-ideal">
                  <li>Residential Homes</li>
                  <li>Apartments</li>
                  <li>Commercial Buildings</li>
                  <li>Institutions</li>
                </ul>
              </div>
              <div className="services-item">
                <h2>3. Commercial Painting</h2>
                <img src={commercial} alt="Flexi Painter" />
                <p>
                  We help businesses maintain professional and beautiful
                  environments through our high-quality painting services. Our
                  team is trained to handle projects of all sizes while
                  minimizing disruption to operations.
                </p>
                <h3>What We Offer</h3>
                <ul className="service-offers">
                  <li>
                    <span className="flexi-skyblue">✔︎ </span> Office Painting
                  </li>
                  <li>
                    <span className="flexi-skyblue">✔︎ </span> Hotel Painting
                  </li>
                  <li>
                    <span className="flexi-skyblue">✔︎ </span> School Painting
                  </li>
                  <li>
                    <span className="flexi-skyblue">✔︎ </span> Hospital Painting
                  </li>
                  <li>
                    <span className="flexi-skyblue">✔︎ </span> Shopping Centre
                    Painting
                  </li>
                  <li>
                    <span className="flexi-skyblue">✔︎ </span> Warehouse Painting
                  </li>
                </ul>
                <h3>Ideal For</h3>
                <ul className="services-ideal">
                  <li>Offices</li>
                  <li>Hotels</li>
                  <li>Educational Institutions</li>
                  <li>Healthcare Facilities</li>
                  <li>Commercial Developments</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesBody;
